import { OfficeFluidAriaInfo, OfficeFluidTestAriaInfo } from './OfficeFluidAriaInfo';
/**
 * Method that returns the aria info for the tenant to route the telemetry to
 */
export function getAriaInfoByAudience(audience) {
    if (isTestTelemetryByStorageHooks() || isTestTelemetryByAudience(audience)) {
        return OfficeFluidTestAriaInfo;
    }
    return OfficeFluidAriaInfo;
}
function isTestTelemetryByAudience(audience) {
    return audience === 'Local' || audience === 'Automation';
}
function isTestTelemetryByStorageHooks() {
    // Known developer support for "sideloading" have been retroactively collected here to assist in mitigating their
    // impact in telemetry when the original feature does not fully account for disinformation that may be caused.
    let developerHookDetected = false;
    try {
        // FluidCodeDetailsOverride and AllowListOverride are used in pairs. So We can just check for the presence of FluidCodeDetailsOverride
        developerHookDetected = !!localStorage.getItem('FluidCodeDetailsOverride');
    }
    catch {
        // Any issue attempting to detect support for or availability of either localStorage property or any part of the Web Storage API indicates there is not a developer hook to detect here.
    }
    return developerHookDetected;
}
//# sourceMappingURL=LogProcessorHelpers.js.map